export default "__VITE_ASSET__CeQkkCE4__"